import React, { useState } from 'react';
import COPY from './data/content';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Certifications from './components/Certifications';
import Projects from './components/Projects';
import Skills from './components/Skills';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  const [lang, setLang] = useState('en');
  const t = COPY[lang];

  return (
    <div className="bg-bg text-ink font-body antialiased">
      <Nav lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <Certifications t={t} />
        <Projects t={t} />
        <Skills t={t} />
        <Testimonials t={t} />
        <About t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}
